import React, { Component, Fragment } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { connect } from "react-redux";

import { getModalData } from "src/selectors";
import { hideModal } from "src/actions/modal.actions";

/**
 * A common confirm and action modal that shows a list of changes to be made
 *
 * modalProps.title {string | component} modal title
 * modalProps.text {string | component} text
 * modalProps.okText {string | component} text
 * modalProps.cancelText {string | component} text
 * modalProps.changes {{ key, oldVal, newVal }[]} changes to show
 * modalProps.action {() => promise} action to be performed on confirmation
 */
class ConfirmChangesAndActionModal extends Component {
  columns = [
    {
      dataField: "key",
      text: "Name",
    },
    {
      dataField: "oldVal",
      text: "Old Value",
      formatter: this.oldValueFormatter,
    },
    {
      dataField: "newVal",
      text: "New Value",
      formatter: this.newValueFormatter,
    },
  ];

  oldValueFormatter = (cell, row) => {
    return <div style={{ maxWidth: "200px", wordBreak: "break-all" }}>{row.oldVal}</div>;
  };

  newValueFormatter = (cell, row) => {
    return <div style={{ maxWidth: "200px", wordBreak: "break-all" }}>{row.newVal}</div>;
  };

  closeModal = () => {
    this.props.hideModal();
  };

  action = () => {
    if (typeof this.props.modalProps.action === "function") {
      const result = this.props.modalProps.action();
      if (result && typeof result.then === "function") {
        result.then(() => this.props.hideModal());
      } else {
        this.props.hideModal();
      }
    }
  };

  render() {
    const { title, text, changes, okText = "Save", cancelText = "Cancel" } = this.props.modalProps;
    return (
      <Fragment>
        <div className="modal" style={{ display: "block" }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button type="button" className="close" onClick={this.closeModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {text && <p className="lead">{text}</p>}
                {changes && changes.length > 0 && (
                  <BootstrapTable
                    classes="table table-striped cmv-table"
                    keyField="key"
                    data={changes}
                    columns={this.columns}
                  />
                )}
              </div>
              <div className="modal-footer">
                <button onClick={this.closeModal} className="btn">
                  {cancelText}
                </button>
                <button onClick={this.action} className="btn btn-primary">
                  {okText}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop show" tabIndex="1" />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const modalProps = getModalData(state).modalProps;

  return {
    modalProps,
  };
};

const mapDispatchToProps = {
  hideModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmChangesAndActionModal);
